import { PagedResult } from './../../../model/common/paged-result';
import { Param } from './../../../model/common/param';
import { Component, EventEmitter, ViewChild } from '@angular/core';
import { GenericManage } from '../../generic/generic.manage';
import { Department } from '../../../model/api/administration/department';
import { DepartmentDetail } from '../../../model/api/administration/department-detail';

import { DepartmentHttpService } from '../../../services/http/administration/department.http.service';
import { DepartmentDetailHttpService } from '../../../services/http/administration/department-detail.http.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DepartmentListComponent } from './department.list';

@Component({
    selector: 'app-department-manage',
    templateUrl: 'department.manage.html',
    providers: [ DepartmentHttpService, DepartmentDetailHttpService ]
})
export class DepartmentManageComponent extends GenericManage<Department, number> {

    @ViewChild('departmentDetailModal') modal: ModalDirective;
    @ViewChild('departmentList') departmentList: DepartmentListComponent;
    @ViewChild('departmentDetail') departmentDetail: DepartmentDetail;

    isCollapsed: boolean = true;
    public filter: string = '';

    constructor(public departmentHttpService: DepartmentHttpService,
        public departmentDetailHttpService: DepartmentDetailHttpService) {

        super();
    }

    public detailInitialize() {
        this.modal.show();
    }

    public detailTerminate() {
        this.modal.hide();
    }

    public refresh() {
        let params: Array<Param> = new Array<Param>();

        params.push(new Param('filter', this.filter));

        this.departmentList.refresh(params);
    }

    public exportToExcel() {

        let params: Array<Param> = null;

        if ((this.filter != null) && (this.filter.length > 0)) {
            params = new Array<Param>();
            params.push(new Param('filter', this.filter));
        }

        this.departmentDetailHttpService.get(1, 1000000, 'name', 'asc', params, null).subscribe(
            (data: PagedResult<Department>) => {

                let options = {
                    sheetid: 'n1',
                    headers: true,
                    column: { style: { Font: { Bold: '1' } } },
                    rows: { 1: { style: { Font: { Color: '#FF0077' } } } },
                    cells: { 1: { 1: { style: { Font: { Color: '#00FFFF' } } } } }
                };

                // alasql(`SELECT id as [Id], 
                //             code as [Cod], 
                //             name as [Denumire]
                //             INTO XLSX("n+1.xlsx",?) FROM ?`, [ options, data.items ]);
            });

    }


    collapsed(event: any): void {
        // console.log(event);
      }
    
      expanded(event: any): void {
        // console.log(event);
      }
}